import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UtilityService } from '../../../services/utility/utility.service';
import { User } from '../../models/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private utilityService: UtilityService) {}

  usersEndpoint = environment.loginApiUrl + '/Users';

  getUserByAzureId(azureId: string): Observable<User> {
    const url = this.usersEndpoint + '?azureId=' + azureId;
    return this.utilityService.getRequest<User>(url);
  }

  getOrInsertUser(user: User): Observable<User> {
    return this.utilityService.postRequest<User>(this.usersEndpoint, user);
  }

  /**
   * Redeem an invitation by its token (from the invite email link). The API binds
   * the caller's Entra identity (from the bearer token) to the invited record —
   * deterministic, no email matching.
   */
  redeemInvite(token: string): Observable<User> {
    return this.utilityService.postRequest<User>(this.usersEndpoint + '/RedeemInvite', { token });
  }
}
